import type { GetDnsResponse } from '@fourthwall/services/dist/DnsApiClient'
import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

type Payload = { domain: string }

export const createDomainMutationKey = 'createDomain'

export const useCreateDomainMutation = () => {
  const createDomainMutation = useMutation<GetDnsResponse, ApiError, Payload>({
    mutationFn: async (payload: Payload) => (await DnsApiClient.createDomain(payload)).data,
    mutationKey: [createDomainMutationKey],
    onError: undefined,
  })

  return { createDomainMutation }
}
